export interface IDeleteNdd {
    id: number,
    alias: string,
    donationStartDate: string
}